import Vue from 'vue'
import store from '@/store/'
import router from '@/router/'
import templates from './templates'

import Main from './Main'
import Mix from './Mix'

const Constructor = Vue.extend(Main)
let instance
let seed = 1

const Modal = async ({fullscreen, beforeCreate, title, name, width, selection, FormTemplate, okText, onSuccess, onError, successTip = true,errorTip = true, steps = 0,hasfooter} = {}) => {
  if (typeof beforeCreate == 'function' && !beforeCreate({router, store})) return

  // 模板组件混合mix，顺便校验是否设置了模版
  try {
    if (FormTemplate.mixins instanceof Array) {
      FormTemplate.mixins.unshift(Mix)
    } else {
      FormTemplate.mixins = [Mix]
    }
  } catch (error) {
    store.dispatch('pushError', error.toString())
    return
  }

  // vue实例的构造过程
  instance = new Constructor({
    propsData: {
      fullscreen,
      title,
      name,
      width,
      onSuccess,
      onError,
      successTip,
      errorTip,
      okText,
      steps,
      selection,
      hasfooter
    },
    components: {
      FormTemplate
    },
    store,
    router
  })
  instance.id = 'modal-' + seed++
  instance.vm = instance.$mount()
  document.body.appendChild(instance.vm.$el)
  instance.vm.$data.value = true
  return instance.vm
}

for (const [method, defaultOpts] of Object.entries(templates)) {
  Modal[method] = (opts = {}) => {
    Modal({...defaultOpts, ...opts})
  }
}

export default Modal
